import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Box,
  Stack,
  useTheme,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import './Schemes.css';
const schemes = [
  {
    title: 'प्रधानमंत्री आवास योजना (PMAY)',
    description: 'Housing scheme for rural residents providing financial assistance for building pucca houses.',
    image: '/pmay2.jpg',
    benefits: ['Financial assistance up to ₹1.20 lakh', 'Additional funding through convergence', 'Technical support'],
  },
  {
    title: 'महात्मा गांधी रोजगार हमी योजना (MNREGA)',
    description: 'Employment guarantee scheme providing 100 days of wage employment.',
    image: '/mgerega.png',
    benefits: ['Guaranteed employment', 'Equal wages for men and women', 'Unemployment allowance'],
  },
  {
    title: 'स्वच्छ भारत मिशन',
    description: 'Clean India Mission focusing on sanitation and waste management.',
    image: '/swach_bharat.png',
    benefits: ['Toilet construction support', 'Waste management', 'Clean village incentives'],
  },
  {
    title: 'दीनदयाल उपाध्याय ग्रामीण कौशल्य योजना',
    description: 'Skill development program for rural youth.',
    image: '/DDUGKY.png',
    benefits: ['Free training', 'Placement assistance', 'Stipend during training'],
  },
  {
    title: 'प्रधानमंत्री कृषि सिंचाई योजना',
    description: 'Irrigation scheme for farmers to improve water efficiency.',
    image: '/pmksy.png',
    benefits: ['Water conservation', 'Improved farming', 'Sustainable practices'],
  },
  {
    title: 'जन धन योजना',
    description: 'Financial inclusion program providing banking services.',
    image: '/pmjdy2.jpg',
    benefits: ['Zero balance account', 'RuPay debit card', 'Insurance coverage'],
  },
];

const Schemes = () => {
  const theme = useTheme();

  return (
    <Box sx={{ py: 6, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        {/* Header Section */}
        <Box sx={{ mb: 6, textAlign: 'center' }}>
          <Typography variant="h3" component="h1" gutterBottom>
            Government Schemes
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
            Explore various government schemes available for village development
          </Typography>
        </Box>

        {/* Schemes Grid */}
        <div >
          <Grid container spacing={4}>
            {schemes.map((scheme, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <CardMedia
                    component="img"
                    height="250"
                    image={scheme.image}
                    alt={scheme.title}
                    sx={{ objectFit: 'cover' }}
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="h5" gutterBottom component="h2">
                      {scheme.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" paragraph>
                      {scheme.description}
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="subtitle1" gutterBottom>
                        Key Benefits:
                      </Typography>
                      <Stack spacing={1}>
                        {scheme.benefits.map((benefit, idx) => (
                          <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ArrowForwardIcon color="primary" fontSize="small" />
                            <Typography variant="body2">
                              {benefit}
                            </Typography>
                          </Box>
                        ))}
                      </Stack>
                    </Box>
                  </CardContent>
                  <Box sx={{ p: 2, pt: 0 }}>
                    <Button variant="contained" color="primary" fullWidth  sx={{backgroundColor: '#00106e'}}>
                      Apply Now
                    </Button>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </div>
      </Container>
    </Box>
  );
};

export default Schemes;
